import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Select, DatePicker, Input, Button, Space, message, ConfigProvider } from 'antd';
import {
  FilePdfOutlined, FileExcelOutlined, DownloadOutlined, SearchOutlined,
  FileSearchOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import classNames from 'classnames';
import styles from "./index.module.css";
import { reportTheme } from './reportTheme';
import { USER_ROLES } from '../../constants/constants';
const { RangePicker } = DatePicker;

export const ReportsSection = ({ organizations, transportCompanies, dateRange, exportReport,
  selHoOrgId, userRole, loading }) => {

  const [activeReport, setActiveReport] = useState(null);
  const [paramValues, setParamValues] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => {

  }, [paramValues]);

  const orgnaization = organizations?.map(org => ({ label: org.name, value: org.id }));
  const tcData = transportCompanies?.map(org => ({ label: org.name, value: org.id }));

  const reports = {
    '7-min-tc-performance': {
      name: 'Ride Start Time (±7 Minutes)',
      description: 'Performance report for transport companies with 7-minute threshold',
      icon: <FilePdfOutlined />,
      params: [
        {
          name: 'dateRange',
          label: 'Date Range',
          type: 'daterange',
          defaultValue: [dayjs().subtract(30, 'days'), dayjs()],
          required: true
        }
      ]
    },
    '15-min-tc-performance': {
      name: 'Ride Start Time (±15 Minutes)',
      description: 'Performance report for transport companies with 15-minute threshold',
      icon: <FilePdfOutlined />,
      params: [
        {
          name: 'dateRange',
          label: 'Date Range',
          type: 'daterange',
          defaultValue: [dayjs().subtract(30, 'days'), dayjs()],
          required: true
        }
      ]
    },
    'monthly-ride-summary': {
      name: 'Ride Summary',
      description: 'Detailed summary of rides',
      icon: <FilePdfOutlined />,
      params: [
        {
          name: 'monthYear',
          label: 'Month & Year',
          type: 'monthpicker',
          defaultValue: dayjs(),
          required: true
        }
      ]
    },
    'ho-user-activity': {
      name: 'HO Active/Inactive Status',
      description: 'Detailed report on user activity',
      icon: <FilePdfOutlined />,
      params: []
    },
    'user-engagement': {
      name: 'User Engagement',
      description: 'Detailed report on User Engagement',
      icon: <FilePdfOutlined />,
      params: []
    },
    'rider-feedback-report': {
      name: 'Rider Feedback',
      description: 'Detailed summary of rider provided feedback',
      icon: <FilePdfOutlined />,
      params: [
        {
          name: 'organizationId',
          label: 'Organization',
          type: 'select',
          options: orgnaization,
          defaultValue: 'all',
          required: true,
        },
        {
          name: 'dateRange',
          label: 'Date Range',
          type: 'daterange',
          required: false
        }
      ]
    }
  };

  const roleBasedReports = {
    [USER_ROLES.HO_ADMIN]: {
      'ho-user-activity': {
        params: []
      }
    },

    [USER_ROLES.ENTERPRISE_ADMIN]:
    {
      'ho-user-activity': {
        params: [
          {
            name: 'organizationId',
            label: 'Organization',
            type: 'select',
            options: orgnaization,
            defaultValue: 'all',
            required: true
          }
        ]
      },
      'user-engagement': {
        params: [
          {
            name: 'organizationId',
            label: 'Organization',
            type: 'select',
            options: orgnaization,
            defaultValue: 'all',
            required: true
          }
        ]
      },
      'rider-feedback-report': {
        params: [
          {
            name: 'organizationId',
            label: 'Organization',
            type: 'select',
            options: orgnaization,
            defaultValue: 'all',
            required: true
          }
        ]
      }
    },

    [USER_ROLES.SUPER_ADMIN]: {
      'driver-performance-report': {
        name: 'Driver Status and Performance ',
        description: 'Detailed report on Driver Performance',
        icon: <FilePdfOutlined />,
        params: [
          {
            name: 'tcId',
            label: 'Transportation Companies',
            type: 'select',
            options: tcData,
            defaultValue: 'all',
            required: true
          },
          {
            name: 'dateRange',
            label: 'Date Range',
            type: 'daterange',
            defaultValue: [dayjs().subtract(30, 'days'), dayjs()],
            required: true
          }
        ]
      },
      'driver-rides-arrival-time': {
        name: 'On-Time Driver Arrivals',
        description: 'Detailed report on driver rides and their arrival times',
        icon: <FilePdfOutlined />,
        params: [
          {
            name: 'monthYear',
            label: 'Month & Year',
            type: 'monthpicker',
            defaultValue: dayjs(), // default to current month
            required: true
          }
        ]
      },
      'overall-tc-performance': {
        name: 'TC Active/Inactive Status',
        description: 'Detailed report on user activity for Health Organization',
        icon: <FilePdfOutlined />,
        params: [
          {
            name: 'tcId',
            label: 'Transportation Companies',
            type: 'select',
            options: tcData,
            defaultValue: 'all',
            required: true
          },
          {
            name: 'dateRange',
            label: 'Date Range',
            type: 'daterange',
            defaultValue: [dayjs().subtract(30, 'days'), dayjs()],
            required: true
          }
        ]
      },
      'ho-user-activity': {
        params: [
          {
            name: 'organizationId',
            label: 'Organization',
            type: 'select',
            options: orgnaization,
            defaultValue: 'all',
            required: true
          }
        ]
      },
      'unfulfilled-transition-report': {
        name: 'Unfulfilled Ride Status Transition',
        description: 'Detailed report on unfulfilled ride status transitions',
        icon: <FilePdfOutlined />,
        params: [
          {
            name: 'organizationId',
            label: 'Organization',
            type: 'select',
            options: orgnaization,
            defaultValue: 'all',
            required: true,
          },
          {
            name: 'dateRange',
            label: 'Date Range',
            type: 'daterange',
            required: false
          }
        ]
      }
    }
  };

  //         {
  //   id: 'Ride-status-summary',
  //   name: 'Ride Summary',
  //   description: 'Detailed summary of rides with filtering options',
  //   icon: <FilePdfOutlined />,
  //   params: [
  //   //   {
  //   //     name: 'format',
  //   //     label: 'Format',
  //   //     type: 'select',
  //   //     options: [
  //   //       { value: 'pdf', label: 'PDF' },
  //   //       { value: 'excel', label: 'Excel' }
  //   //     ],
  //   //     defaultValue: 'pdf',
  //   //     required: true
  //   //   },
  //     {
  //       name: 'status',
  //       label: 'Status',
  //       type: 'select',
  //       options: [
  //         { value: 'all', label: 'All Statuses' },
  //         { value: 'Completed', label: 'Completed' },
  //         { value: 'Pending', label: 'Pending' }
  //       ],
  //       defaultValue: 'all'
  //     }
  //   ]
  // },
  // {
  //   id: 'driver-performance',
  //   name: 'Driver Performance',
  //   description: 'Detailed analysis of driver metrics',
  //   icon: <FileExcelOutlined />,
  //   params: [
  //   //   {
  //   //     name: 'format',
  //   //     label: 'Format',
  //   //     type: 'select',
  //   //     options: [
  //   //       { value: 'pdf', label: 'PDF' },
  //   //       { value: 'excel', label: 'Excel' }
  //   //     ],
  //   //     defaultValue: 'excel',
  //   //     required: true
  //   //   },
  //     {
  //       name: 'timePeriod',
  //       label: 'Time Period',
  //       type: 'select',
  //       options: [
  //         { value: 'last7', label: 'Last 7 Days' },
  //         { value: 'last30', label: 'Last 30 Days' },
  //         { value: 'custom', label: 'Custom Range' }
  //       ],
  //       defaultValue: 'last30'
  //     }
  //   ]
  // },
  // {
  //   id: 'billing-summary',
  //   name: 'Billing Summary',
  //   description: 'Financial summary for billing purposes',
  //   icon: <FileExcelOutlined />,
  //   params: [
  //     {
  //       name: 'organization',
  //       label: 'Organization',
  //       type: 'select',
  //       options: [
  //         { value: 'all', label: 'All Organizations' },
  //         ...organizations.map(org => ({
  //           value: org.id,
  //           label: org.name
  //         }))
  //       ],
  //       defaultValue: 'all'
  //     },
  //     {
  //       name: 'transportCompany',
  //       label: 'Transport Company',
  //       type: 'select',
  //       options: [
  //         { value: 'all', label: 'All Companies' },
  //         ...transportCompanies.map(tc => ({
  //           value: tc.id,
  //           label: tc.name
  //         }))
  //       ],
  //       defaultValue: 'all'
  //     }
  //   ]
  // }


  const getUserReports = (userRole) => {
    const roleBased = roleBasedReports[userRole] || {};

    // 1. Merge base reports + roleBased overrides
    const merged = Object.entries(reports).map(([id, report]) => {
      const override = roleBased[id] || {};

      return {
        id,
        ...report,
        ...override, // merge name, report, etc.
        params: override.params ?? report.params
      };
    });

    // 2. Add NEW reports that ONLY exist in roleBased (not in base reports)
    const extraReports = Object.entries(roleBased)
      .filter(([id]) => !reports[id])   // only those NOT in base reports
      .map(([id, rpt]) => ({
        id,
        ...rpt
      }));

    return [...merged, ...extraReports];
  };

  // applying filter on only Report Title name
  const filteredReports = getUserReports(userRole).filter(report =>
    report.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle parameter changes
  const handleParamChange = (paramName, value) => {
    setParamValues(prev => {
      if (paramName === 'dateRange') {


        if (value && value.length === 2) {
          return {
            ...prev,
            [paramName]: [value[0], value[1]], // Store dayjs objects directly
          };
        } else {
          return {
            ...prev,
            [paramName]: null, // Clear the range if no value
          };
        }
      }
      // For monthpicker, store the dayjs object directly
      if (paramName === 'monthYear' && value) {
        return {
          ...prev,
          [paramName]: value,
        };
      }
      return {
        ...prev,
        [paramName]: value,
      };
    });


  };

  // Generate report
  const downloadReport = (report) => {
    // Clone paramValues to avoid mutation
    const params = { ...paramValues };
    // Convert monthpicker value to { month, year }

    report.params?.forEach(param => {
      if (param.type === 'monthpicker' && params[param.name]) {
        params[param.name] = {
          month: params[param.name].month() + 1,
          year: params[param.name].year(),
        };
      } else if (param.type === 'daterange' && params[param.name]) {


        params[param.name] = {
          startDate: params[param.name]?.[0] ? params[param.name]?.[0] : null,
          endDate: params[param.name]?.[1] ? params[param.name]?.[1] : null,
          startDate: params[param.name]?.[0] ? params[param.name]?.[0] : null,
          endDate: params[param.name]?.[1] ? params[param.name]?.[1] : null,
        };
      }
    });

    if (selHoOrgId && selHoOrgId != 'all') {
      params['organizationId'] = selHoOrgId;
    }


    exportReport({ id: report.id, params });
    // message.success(`Generating ${report.name} with selected parameters`);
  };

  return (
    <ConfigProvider theme={reportTheme}>
      <Card className={classNames({ [styles.searchCard]: true })}
        // title="Available Reports" 
        loading={loading}
        extra={
          //   <Space>
          //     <Button 
          //       type="primary" 
          //     //   className={classNames({
          //     //     [styles.btn]: true,
          //     //     [styles.customBtn]: true,

          //     //   })}
          //       disabled={!activeReport}
          //       onClick={() => downloadReport(activeReport)}
          //     >
          //       Download
          //     </Button>
          //   </Space>
          <Space style={{ width: '100%' }} className={classNames({ [styles.searchCardInput]: true })}>
            {/* <div>Select Report</div> */}
            <Input
              placeholder="Search reports..."
              allowClear
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              prefix={<SearchOutlined />}
              style={{ width: '100%' }}
            />
          </Space>
        }
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} md={10}>
            <Card
              // title={

              // }
              bodyStyle={{ padding: 0 }}
            >
              <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {filteredReports.length > 0 ? (
                  filteredReports.map(report => (
                    <Card.Grid
                      key={report.id}
                      style={{
                        width: '100%',
                        cursor: 'pointer',
                        backgroundColor: activeReport?.id === report.id ? '#f0f7ff' : 'inherit',
                        padding: '10px'
                      }}
                      onClick={() => {
                        setActiveReport(report);
                        // Build defaults object for all params
                        const defaults = {};
                        report.params?.forEach(param => {


                          if (param.type === 'daterange' && Array.isArray(param.defaultValue) && param.defaultValue.length === 2) {


                            defaults[param.name] = {

                              startDate: param.defaultValue[0] ? dayjs(param.defaultValue[0]).format('MM-DD-YYYY') : null,
                              endDate: param.defaultValue[1] ? dayjs(param.defaultValue[1]).format('MM-DD-YYYY') : null,
                            };
                          } else {
                            defaults[param.name] = param.defaultValue;
                          }


                        });

                        setParamValues(defaults);
                      }}
                    >
                      <Space>
                        {report.icon}
                        <div>
                          <strong>{report.name}</strong>
                          <div style={{ fontSize: 12, color: '#666' }}>
                            {report.description}
                          </div>
                        </div>
                      </Space>
                    </Card.Grid>
                  ))
                ) : (
                  <div style={{
                    padding: 16,
                    textAlign: 'center',
                    color: '#999'
                  }}>
                    <FileSearchOutlined style={{ fontSize: 24, marginBottom: 8 }} />
                    <div>No reports match your search</div>
                  </div>
                )}
              </div>
            </Card>
          </Col>

          <Col xs={24} md={14}>
            {activeReport ? (
              <Card
                title={`Filters`}
                bodyStyle={{ paddingTop: 16 }}
              >
                <Row gutter={[16, 16]}>
                  {activeReport.params?.map(param => (
                    <Col xs={24} sm={12} key={param.name}>
                      <div style={{ marginBottom: 8 }}>
                        <strong>{param.label}</strong>
                        {param.required && (
                          <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                        )}
                      </div>

                      {param.type === 'select' ? (
                        <Select
                          style={{ width: '100%' }}
                          value={paramValues[param.name] || param.defaultValue}
                          onChange={value => handleParamChange(param.name, value)}
                          options={param.options}
                        />
                      ) : param.type === 'date' ? (
                        <DatePicker
                          style={{ width: '100%' }}
                          value={paramValues[param.name] ? dayjs(paramValues[param.name]) : null}
                          onChange={date => handleParamChange(param.name, date ? date.format('YYYY-MM-DD') : null)}
                        />
                      ) : param.type === 'monthpicker' ? (
                        <DatePicker
                          picker="month"
                          style={{ width: '100%' }}
                          value={paramValues[param.name] ? dayjs(paramValues[param.name]) : null}
                          onChange={date => handleParamChange(param.name, date)}
                          format="MMMM YYYY"
                        />
                      ) : param.type === 'daterange' ? (
                        <RangePicker
                          style={{ width: '100%' }}
                          value={paramValues[param.name] ? [
                            dayjs(paramValues[param.name][0]),
                            dayjs(paramValues[param.name][1])
                          ] : null}
                          onChange={dates => handleParamChange(param.name, dates ? [
                            dates[0].format('YYYY-MM-DD'),
                            dates[1].format('YYYY-MM-DD')
                          ] : null)}
                        />
                      ) : (
                        <Input
                          value={paramValues[param.name] || ''}
                          onChange={e => handleParamChange(param.name, e.target.value)}
                        />
                      )}
                    </Col>
                  ))}
                </Row>

                <div style={{ marginTop: 24 }}>
                  <Button
                    //    className={classNames({
                    //     [styles.btn]: true,
                    //     [styles.customBtn]: true,

                    //   })}
                    type="primary"
                    onClick={() => downloadReport(activeReport)}
                    icon={<DownloadOutlined />}
                  >
                    Download
                  </Button>

                  <Button
                    // className={classNames({
                    //     [styles.btn]: true,
                    //     [styles.customBtn]: true,

                    //   })}
                    style={{ marginLeft: 8 }}
                    onClick={() => {
                      // Reset to default values
                      const defaults = {};
                      activeReport.params?.forEach(param => {
                        defaults[param.name] = param.defaultValue;
                      });
                      setParamValues(defaults);
                    }}
                  >
                    Clear All
                  </Button>
                </div>
              </Card>
            ) : (
              <Card>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: 200,
                  color: '#999'
                }}>
                  <div style={{ textAlign: 'center' }}>
                    <FilePdfOutlined style={{ fontSize: 32, marginBottom: 8 }} />
                    <div>Select a report from the list to configure parameters</div>
                  </div>
                </div>
              </Card>
            )}
          </Col>
        </Row>
      </Card>
    </ConfigProvider>
  );
};